<div class="center">
  <img _ngcontent-hda-c5="" src="assets/logo/ms-icon-144x144.png" width="155" height="155" style="position: absolute;margin-left: -77px;top: 281px;">
  <qrcode [qrdata]="qrdata" [size]="1000" [level]="'M'" [width]="getWidth()"></qrcode>
  
</div>
<div class="center">
  SCAN AND REGISTER
</div>

<router-outlet></router-outlet>